import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import {Modal} from "ngx-modal";
import { ISubscription } from 'rxjs/Subscription';
import { SubscriptionService } from '../services/subscription.service';

@Component({
  selector: 'dac-subscription-dialog',
  templateUrl: './subscription-dialog.component.html',
  styleUrls: ['./subscription-dialog.component.scss']
})
export class SubscriptionDialogComponent implements OnInit, OnDestroy {

  @ViewChild('modal') modal: Modal;
  private _isOpen:boolean;

  private _subscriptionServiceSubscription:ISubscription;

  constructor(private subscriptionService:SubscriptionService
    ,private route:ActivatedRoute
    ,private router:Router
  ) { 
    this._isOpen = false;
  }

  public handleClose() {
    this._isOpen = false;
  }
  public goToSubscriptionSignup() {
    this.router.navigate(this.subscriptionService.getSubscriptionPageRoute()).then(() => {
      this.closeDialog();
    });
  }
  private openDialog() {
    if (!this._isOpen) {
        this.modal.open();
    }
    this._isOpen = true;
  }
  private closeDialog() {
    if (this._isOpen) {
      this.modal.close();
    }
    this._isOpen = false;
  }
  ngOnInit() {
    this._subscriptionServiceSubscription = this.subscriptionService.subscriptionRequiredEvent().subscribe(() => {
      this.openDialog();
    });
  }

  ngOnDestroy() {
    this._subscriptionServiceSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/subscription-dialog/subscription-dialog.component.ts